import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppMainComponent } from 'src/app/app.main.component';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AuthService } from 'src/app/auth/auth.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { getUserDefaultProfile, getUserRoles } from 'src/app/core/functions';
import { Permission } from 'src/app/core/enums/permissions';
import { Profile } from 'src/app/core/enums/profile';
import { SharedUserDataService } from 'src/app/shared/shared-user-data.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-inlinemenu',
    templateUrl: './app.inlinemenu.component.html',
    standalone: false
})
export class AppInlineMenuComponent implements OnInit, OnDestroy {
  inlineMenuActive = false;
  employeeId: string;
  profile: Profile;
  fullName: string;
  email: string;
  private subsAvatar: Subscription;
  private subsAuth: Subscription;

  constructor(
    public appMain: AppMainComponent,
    public afAuth: AngularFireAuth,
    public authService: AuthService,
    public sharedUserDataService: SharedUserDataService
  ) {
    const avatar = this.sharedUserDataService.getAvatarValue();
    if (avatar) {
      this.fullName = avatar.fullName;
    }
  }

  toggleMenu() {
    this.inlineMenuActive = !this.inlineMenuActive;
  }

  ngOnInit(): void {
    this.subsAuth = this.afAuth.idTokenResult.subscribe((user) => {
      if (user) {
        this.profile = getUserDefaultProfile(user.claims);
        this.email = user.claims['email'] as string;
      }
    });
    this.subsAvatar = this.sharedUserDataService.getAvatar()
      .subscribe(avatar => {
        this.fullName = avatar.fullName;
      });
  }

  ngOnDestroy(): void {
    this.subsAvatar?.unsubscribe();
    this.subsAuth?.unsubscribe();
  }

  logout() {
    this.authService.SignOut();
  }
}

